export default function WhyChoose() {
  const benefits = [
    {
      icon: 'ri-time-line',
      title: 'Reduced downtime and lost billable hours'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Improved security and compliance confidence'
    },
    {
      icon: 'ri-speed-line',
      title: 'Faster IT response for attorneys and staff'
    },
    {
      icon: 'ri-eye-line',
      title: 'Clear visibility into IT costs and risks'
    },
    {
      icon: 'ri-team-line',
      title: 'A long-term technology partner—not a break/fix vendor'
    }
  ];

  return (
    <section id="why-choose" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-serif text-[#1A1F2E] leading-tight mb-6">
            Why Law Firms Choose Avert
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed font-light">
            Built for Firms That Value Time, Trust, and Precision
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 border border-gray-200 hover:border-[#e10708] transition-all duration-300 hover:shadow-lg"
            >
              <div className="flex items-start">
                <div className="w-10 h-10 bg-[#e10708]/10 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className={`${benefit.icon} text-[#e10708] text-xl w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <p className="text-base text-gray-700 font-medium leading-relaxed">
                  {benefit.title}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-[#1A1F2E] to-[#2A2F3E] rounded-3xl p-12 text-center">
          <p className="text-2xl lg:text-3xl text-white font-light leading-relaxed mb-8">
            Whether you're a single-office practice or a multi-location firm, Avert Network Services delivers IT and cybersecurity solutions that scale with your firm—without disrupting your workflow.
          </p>

          <p className="text-white/80 text-lg mt-8 font-light italic">
            Your attorneys should be billing—not waiting on IT.
          </p>
        </div>
      </div>
    </section>
  );
}
